import React, { useContext, useEffect, useState } from 'react';
import { Genre, Section, UserData } from 'common/constants/types';
import MiddlePane from './MiddlePane/MiddlePane';
import RightPane from './RightPane/RightPane';
import { EditUserContext } from '../context';

import styles from './UserDetailContainer.module.scss';
import { fetchNewUserData } from './userDetailContainerStateUtils';

// change return type to Section[] after MiddlePane is Typescript and this doesn't break inferred props
const getSections = (userData: UserData, editUser: boolean, onlyUserInfo = true): Section[] => {
  const { genres } = userData;

  if (onlyUserInfo) {
    if (editUser && genres) {
      const combinedInfo = genres.reduce(
        (prev, curr) => ({
          sections: [...prev.sections, ...curr.sections],
        }),
        { sections: [] } as { sections: Section[] }
      );
      return combinedInfo.sections;
    }
    const genre = genres && genres.find(v => v.name === 'user-info');
    return (genre && genre.sections) || [];
  }

  return genres && genres.flatMap(genre => genre.sections);
};

// Filter out the user-info genre from the userData object.
const filterOutGenre = (userData: UserData, genreToFilter: string): Genre[] =>
  userData.genres ? userData.genres.filter(genre => genre.name !== genreToFilter) : [];

interface Props {
  userIds?: number[];
}

const UserDetailContainer = ({ userIds = [] }: Props) => {
  const [userData, setUserData] = useState({} as UserData);
  const [showAttributeStartTime, setShowAttributeStartTime] = useState(false);
  const [showAttributeEndTime, setShowAttributeEndTime] = useState(false);
  const { editUser, setEditUser } = useContext(EditUserContext);

  useEffect(() => {
    fetchNewUserData(userIds, setUserData, showAttributeEndTime);
  }, [showAttributeEndTime, userIds]);

  return (
    <div className={styles.paneWrapper}>
      <div className={styles.middlePane}>
        <MiddlePane
          activeSections={getSections(userData, editUser, !showAttributeStartTime)}
          editUser={editUser}
          setEditUser={setEditUser}
          setShowAttributeEndTime={setShowAttributeEndTime}
          setShowAttributeStartTime={setShowAttributeStartTime}
          setUserData={setUserData}
          showAttributeEndTime={showAttributeEndTime}
          showAttributeStartTime={showAttributeStartTime}
          userIds={userIds}
        />
      </div>
      <div className={`${styles.rightPane} ${showAttributeStartTime && styles.hide}`}>
        {!editUser && <RightPane {...{ genres: filterOutGenre(userData, 'user-info') }} />}
      </div>
    </div>
  );
};

export default UserDetailContainer;
